<!-- Header above table -->
<div class="w-100 mb-1 table-top-container clearfix">
  <div class="top-left-container form-inline">
    <div class="d-flex align-items-start">
      <div id="notMobile" class="btn-container hidden-sm">
        <pcg-button-hide-show class="hidden-sm" [columnDefs]="columnDefs"></pcg-button-hide-show>
        @if (filterId) {
          <pcg-button-filter id="pcg-button-filter" class="ml-1 hidden-sm" [filterId]="filterId"></pcg-button-filter>
        }
        @if (showResetFilterBtn()) {
          <pcg-button-reset-filter class="ml-1 hidden-sm"></pcg-button-reset-filter>
        }
      </div>
    </div>
  </div>

  @if (filterMap && btnFilterService.getActiveFilters(ajaxData, filterMap)) {
    <div>
      <div class="applied-filters top-left-container form-inline alert-success d-flex flex-row align-items-start form-control-sm" role="alert">
        Applied Filters: {{ btnFilterService.getActiveFilters(ajaxData, filterMap) }}
      </div>
    </div>
  }

  @if (canGlobalSearch) {
    <div class="search-container form-inline">
      @if (canExactMatchSearch) {
        <div class='exact-match-container'>
          <div class='form-check form-check-inline'>
            <label [for]='"exactMatch" + uniqueId' class='form-check-label mr-2'>Exact Match</label>
            <ui-switch #exactMatch [id]='"exactMatch" + uniqueId' (click)='exactMatchSource.next(exactMatch.checked)'></ui-switch>
          </div>
        </div>
      }
      <div class="order-first order-md-last">
        <div class="hidden-md-plus">
          <label class="for">Search:</label>
        </div>
        <input aria-label="Table search" type="search" class="form-control form-control-sm"
          placeholder="Search..." (keyup)="filterSource.next($event.target.value)" (click)="clearSearch($event)"/>
        </div>
      </div>
    }

    <div id="isMobile" class="btn-container hidden-md-plus">
      <pcg-button-hide-show [columnDefs]="columnDefs"></pcg-button-hide-show>
      @if (filterId) {
        <pcg-button-filter id="pcg-button-filter" [filterId]="filterId"></pcg-button-filter>
      }
      @if (showResetFilterBtn()) {
        <pcg-button-reset-filter></pcg-button-reset-filter>
      }
    </div>
  </div>
